import { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import Auxiliary from '../../../hoc/Auxiliary/Auxiliary';
import DataTable from '../../../components/Datatable/DataTable';

class MemberAddressListing extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { t } = this.props;
        let data = [];
        const columns = [
            { text: t("member-address.name"), dataField: 'name', sort: false },
            { text: t("member-address.contact-no"), dataField: 'contact_no', sort: false },
            { text: t("member-address.address-type"), dataField: 'address_type', sort: false },
            { text: t("member-address.default-address"), dataField: 'default_address', sort: false },
            { text: t("member-address.full-address"), dataField: 'full_address', sort: false }
        ]
        if (this.props.data) {
            data = this.props.data.map((val, index) => {
                let default_address = val.default_address > 0 ? t('global._yes') : t('global._no');
                return {
                    name: val.Signer,
                    contact_no: val.Phone,
                    address_type: t(`member-address.address-type-desc.${val.AddType}`),
                    default_address: default_address,
                    full_address: val.Address
                };
            });
        }

        return (
            <Auxiliary>
                <div className='row col-sm'>
                    <div className='col-xl-12'>
                        <div className='card'>
                            <div className='card-header pb-0'>
                                <div className='d-flex justify-content-between'>
                                    <h4 className='card-title mg-b-0'>{t('member-address.subtitle')}</h4>
                                </div>
                            </div>
                            <div className='card-body'>
                                <div className='table-responsive table-hover database'>
                                    <DataTable
                                        keyField="id"
                                        data={data}
                                        columns={columns}
                                        activePage={this.props.activePage}
                                        limit={this.props.limit}
                                        totalItems={this.props.totalRecords}
                                        paginationHandler={(val) => this.props.datatablesChangeHandler(val, "activePage")}
                                        sizePerPageHandler={(val) => this.props.datatablesChangeHandler(val, "limit")}
                                        // searchChangeHandler={(val) => this.props.datatablesChangeHandler(val, "searchValue")}
                                        classValue="dataTable table-bordered text-justify text-center"
                                        loading={this.props.loading}
                                        hideSearchBar={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

export default withNamespaces('translation')(MemberAddressListing);